module.exports = __webpack_public_path__ + "img/01-pic-kids.c3960a55.png";